import { JSX } from "react";
import { useParams } from "react-router-dom";
import NotFoundScreen from "./404";

export default function ValidateUUID({
  id = "id",
  optional = false,
  children,
}: {
  id?: string;
  // allow the param to be absent, e.g. for optional route segments
  optional?: boolean;
  children: JSX.Element;
}) {
  const params = useParams();
  if (optional && params[id] === undefined) return children;
  const validUUIDFormat = params[id]?.match(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
  );
  if (!validUUIDFormat) return <NotFoundScreen />;
  return children;
}
